import { useState } from "react";
import { Button } from "../../common/Button";
import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";


import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,  
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  Btn,
  LanguageSwitch,
  LanguageSwitchContainer,
  // CustomNavLinkSmall,
  // Span,
  // Label
} from "./styles";


  

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {

  // const [visible, setVisibility] = useState(false);

  // const toggleButton = () => {
  //   setVisibility(!visible);
  // };
  // const scrollTo = (id: string) => {
  //     const element = document.getElementById(id) as HTMLDivElement;
  //     element.scrollIntoView({
  //       behavior: "smooth",
  //     });
  //     setVisibility(false);
  //   };


  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  
  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact Info")}</Language>
             <Para> <strong>Address: </strong> 5 Block E2 AWT Phase 2 Lahore</Para> 
              <Para> <strong>Email: </strong> support@andes.pk</Para>
              <Para> <strong>Phone: </strong> +92 329 4625439 </Para>
              {/* <Large to="/">{t("Tell us everything")}</Large> */}
              {/* <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:l.qqbadze@gmail.com">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a> */}
            </Col>

            {/* <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Andes Pharma")}</Title>

             
              <a href="/">
                <Para>{t(`About`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/blog">
              <Para>{t(`Blog`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/sellerpolicy">
                <Para>{t(`Seller Policy`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/privacypolicy">
              <Para>{t(`Privacy Policy`)}</Para>
              </a>
            </Col> */}
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Andes Pharma")}</Title>
              <a href="/">
                <Para>{t(`About`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/blog">
              <Para>{t(`Blog`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/sellerpolicy">
                <Para>{t(`Seller Policy`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/privacypolicy">
              <Para>{t(`Privacy Policy`)}</Para>
              </a>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
             <Title>{t("My Portal")}</Title>             
              <a href="https://pharma.andes.pk/purchase_history">
                <Para>{t(`Order History`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/track-your-order">
              <Para>{t(`Track Order`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/shops/create">
                <Para>{t(`Be a Seller`)}</Para>
              </a>
              {/* <a href="https://pharma.andes.pk/privacypolicy">
              <Para>{t(`Privacy Policy`)}</Para>
              </a> */}
            </Col>


            {/* <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Andes Pharma")}</Title>             
              <a href="/">
                <Para>{t(`About`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/blog">
              <Para>{t(`Blog`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/sellerpolicy">
                <Para>{t(`Seller Policy`)}</Para>
              </a>
              <a href="https://pharma.andes.pk/privacypolicy">
              <Para>{t(`Privacy Policy`)}</Para>
              </a>
            </Col> */}
            



          </Row>
          <Row justify="space-between">
            {/* <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Address")}</Language>
              <Para>Rancho Santa Margarita</Para>
              <Para>2131 Elk Street</Para>
              <Para>California</Para>
            </Col> */}
            {/* <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Company")}</Title>

             


              <Large to="#product">{t("About")}</Large>
              <Large to="/">{t("Blog")}</Large>
              <Large to="/">{t("Press")}</Large>
              <Large to="/">{t("Careers & Culture")}</Large>
            </Col> */}
            {/* <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col> */}
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="#"
                src="iconmonstr-instagram-11.png"
              />
              <SocialLink
                href="#"
                src="twitter.svg"
              />
              <SocialLink
                href="#"
                src="linkedin.svg"
              />
              <SocialLink
                href="#"
                src="298-2983746_facebook.png"
              />
              <a
                href="https://pharma.andes.pk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Btn> Order Now </Btn>
                {/* <img
                  height="36"
                  style={{ border: 0, height: 36 }}
                  src="https://storage.ko-fi.com/cdn/kofi3.png?v=3"
                  alt="Buy Me a Coffee at ko-fi.com"
                /> */}
              </a>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
